<template>
    <div class="col col-md-8 offset-md-2 backgroundForm">
        <div class="d-none d-sm-block">
            
        </div>
        <div class="alert alert-primary" role="alert">
            <h4 class="alert-heading">Despacho de Naves</h4>
                
                <hr>
            <p class="mb-0">Por favor elija una de los dos opciones</p>
        </div>
        <div class="row">
            <div class="col col-md-4 offset-md-2">
            <button class="btn btn-outline-success" @click="confirmSearch">CON REGISTRO EN LA DGCP</button>
            </div>
            <div class="col col-md-4">
            <button class="btn btn-outline-danger" @click="negateSearch">SIN REGISTRO EN LA DGCP</button>
            </div>
        </div>    
    </div>
</template>
<script>
export default {
    name:'question',
    methods:{
        confirmSearch(){
            
            this.$router.push('/dashboard/search')
            this.$store.dispatch('addTitleDispatch', 'Con Registro');
        },
        negateSearch(){
            this.$store.dispatch('addTitleDispatch', 'Sin Registro');
            this.$store.dispatch('changeDisabled',false);
            this.$store.dispatch('deleteBoat',true);
            this.$router.push('/dashboard/not-register');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cotizacion/Question.vue